export const environment = {
    production: false,
    firebaseConfig: {
        apiKey: "AIzaSyCArW2fbEW3ltebMXhMNXcVMrzlt5m5dGo",
        authDomain: "nvtnclb-aia-poc.firebaseapp.com",
        projectId: "nvtnclb-aia-poc",
        storageBucket: "nvtnclb-aia-poc.firebasestorage.app",
        messagingSenderId: "1002469329727",
        appId: "1:1002469329727:web:558c9590480aa2177aa18a"
    }
};
